module.exports = __webpack_public_path__ + "static/media/front_04.b85237c1.png";